import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'LN',
  category: FunctionCategory.MATH,
  shortDescription: "The logarithm of a number, base e (Euler's number).",
  description: "Returns the logarithm of a number, base e (Euler's number).",
  params: [
    {
      name: 'value',
      type: ArgType.positiveNumber,
      description: 'The value for which to calculate the logarithm, base e.',
    },
  ],
  eval: (value: number): number => Math.log(value),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
